import { instance } from '@/api'

const INTEGRATION_AMOCRM_URL = 'amo/tokens'

export default {

  // Получение токена AmoCrm
  async getToken () {
    return await instance.get(INTEGRATION_AMOCRM_URL)
  },

  // Установка токена AmoCrm
  // data: {
  //     "access_token": "...",
  //     "deadline": "2030-12-31"
  // }
  async setToken (data) {
    return await instance.post(INTEGRATION_AMOCRM_URL, data)
  }
}
